export default __webpack_public_path__ + "static/media/achive3.3f7139f1.JPG";